// API Configuration
const API_CONFIG = {
  baseURL: (window.ENV && window.ENV.REACT_APP_API_URL) || process.env.REACT_APP_API_URL || 'http://localhost:5000',
  timeout: 10000,
  retryAttempts: 3,
  retryDelay: 1000,
  healthCheckInterval: 30000 // 30 seconds
};

// Health check function
export const checkServerHealth = async () => {
  try {
    const baseURL = (window.ENV && window.ENV.REACT_APP_API_URL) || process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const healthUrl = `${baseURL}/api/health`;
    const response = await fetch(healthUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      return { healthy: true, data };
    }
    
    return { healthy: false, error: `Server responded with status ${response.status}` };
  } catch (error) {
    return { healthy: false, error: error.message };
  }
};

// Retry function for API calls
export const retryApiCall = async (apiCall, maxRetries = API_CONFIG.retryAttempts) => {
  let lastError;
  
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await apiCall();
    } catch (error) {
      lastError = error;
      
      if (attempt === maxRetries) {
        throw error;
      }
      
      // Wait before retrying
      await new Promise(resolve => setTimeout(resolve, API_CONFIG.retryDelay * attempt));
    }
  }
  
  throw lastError;
};

export default API_CONFIG;